export enum ShapeType {
    none = 'none',
    A1 = 'A1',
    A2 = 'A2',
    A3 = 'A3',
    A4 = 'A4',
    F1 = 'F1',
    F2 = 'F2',
    F3 = 'F3',
}